import { Tooltip } from 'devextreme-react/tooltip';
import { Button } from 'devextreme-react/button';
import { EAFacturarEnableOptions, EFEVRIPSStatus } from '../../../../types/types.preorders';
import { errorInvoice, successInvoice, warningInvoice } from '../../../../images/icons';

interface FEVRIPSStatusButtonProps {
  fevStatus: EFEVRIPSStatus | null | undefined;
  ripsStatus?: EFEVRIPSStatus | null | undefined;
  enableOptions: EAFacturarEnableOptions;
  fevNumero?: string | null;
  onClick: () => void;
  disabled?: boolean;
  hasOrder?: boolean;
}

/**
 * Componente que muestra el estado de FEV/RIPS como un botón en la toolbar
 */
const FEVRIPSStatusButton = ({ fevStatus, ripsStatus, enableOptions, fevNumero, onClick, disabled = false, hasOrder = false }: FEVRIPSStatusButtonProps) => {
  
  // Obtener el texto del estado para el tooltip
  const getStatusText = (status: EFEVRIPSStatus | null | undefined) => {
    switch (status) {
      case EFEVRIPSStatus.Pending:
        return 'Preparado';
      case EFEVRIPSStatus.Sending:
        return 'Enviando';
      case EFEVRIPSStatus.Success:
        return 'Exitoso';
      case EFEVRIPSStatus.Error:
        return 'Error';
      default:
        return 'Sin procesar';
    }
  };

  // Determinar el icono según el estado
  const getIcon = () => {
    // Si alguno está en error, mostrar error
    if (fevStatus === EFEVRIPSStatus.Error || ripsStatus === EFEVRIPSStatus.Error) {
      return errorInvoice;
    }
    // Si es modo FEV+RIPS y FEV exitoso pero RIPS no
    if (enableOptions === EAFacturarEnableOptions.FEV_RIPS) {
      if (fevStatus === EFEVRIPSStatus.Success && ripsStatus !== EFEVRIPSStatus.Success) {
        return warningInvoice; // Falta RIPS
      }
      if (fevStatus === EFEVRIPSStatus.Success && ripsStatus === EFEVRIPSStatus.Success) {
        return successInvoice; // Ambos exitosos
      }
    }
    // Si es modo FEV y está exitoso
    if (fevStatus === EFEVRIPSStatus.Success) {
      return successInvoice;
    }
    // Si está pendiente o enviando, mostrar warning
    if (fevStatus === EFEVRIPSStatus.Pending || fevStatus === EFEVRIPSStatus.Sending) {
      return warningInvoice;
    }
    // Por defecto (sin procesar)
    return warningInvoice;
  };

  const getTooltipContent = () => {
    if (!hasOrder) {
      return 'No hay orden asociada. Cree una orden para habilitar la facturación.';
    }

    const lines: string[] = [];

    lines.push(`FEV: ${getStatusText(fevStatus)}`);
    if (fevNumero) {
      lines.push(`Factura: ${fevNumero}`);
    }

    if (enableOptions === EAFacturarEnableOptions.FEV_RIPS) {
      lines.push(`RIPS: ${getStatusText(ripsStatus)}`);
    }

    lines.push('');
    lines.push('Clic para ver detalles');

    return lines.join('\n');
  };

  // Texto del botón según la opción habilitada
  const getButtonText = () => {
    return enableOptions === EAFacturarEnableOptions.FEV_RIPS ? 'FEV+RIPS' : 'FEV';
  };

  return (
    <div className='messages'>
      <Button id='fevrips-status-btn' icon={getIcon()} text={getButtonText()} stylingMode='text' onClick={onClick} disabled={disabled} />
      <Tooltip target='#fevrips-status-btn' showEvent='mouseenter' hideEvent='mouseleave' position='top'>
        <div style={{ whiteSpace: 'pre-line', padding: '4px' }}>{getTooltipContent()}</div>
      </Tooltip>
    </div>
  );
};

export default FEVRIPSStatusButton;
